<template>
	<!--中按钮-->
	<button type="button" @click="$emit('click')" class="btn-md ft-size-16" :class="classCpt">
		<slot>submit</slot>
	</button>
</template>

<script>
	export default{
		inheritAttrs:false,//根元素不继承特性 可使用与原生一样的属性
		props:['classCpt'],
		data(){
			return{
				 
			}
		},
		methods:{
			childCptFn(){
				
			}
		}
	}
</script>

<style scoped>
	
</style>


// WEBPACK FOOTER //
// src/components/BaseCpts/btnMiddle.vue